import type { ComponentPropsWithRef } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export const ClearAllButton = ({ className, type = 'button', ...props }: ComponentPropsWithRef<'button'>) => {
    const { t } = useTranslation('plpFilters');
    return (
        <button
            type={type}
            data-slot="clear-all"
            className={cn(
                'cursor-pointer whitespace-nowrap text-base leading-5 tracking-[0.16px] underline underline-offset-4',
                className
            )}
            {...props}>
            {t('clearAll')}
        </button>
    );
};
